import React from "react";
import { RadioGroupState } from "react-stately";

export const RadioContext = React.createContext<RadioGroupState>({
  name: "",
  isDisabled: false,
  isRequired: false,
  isReadOnly: false,
  selectedValue: null,
  setSelectedValue(value: string): void {
    throw new Error("Function not implemented.");
  },
  lastFocusedValue: null,
  setLastFocusedValue(value: string): void {
    throw new Error("Function not implemented.");
  },
  validationState: "valid",
});
